import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import * as flowGuards from '../../core/guards';
import { ContactInfoComponent } from './containers/contact-info.component';

const routes: Routes = [
  {
    path: '',
    component: ContactInfoComponent,
    title: 'Your address and phone | Vanguard',
    data: {
      pageId: 'contact_info',
    },
    canActivate: [flowGuards.DataGuard, flowGuards.LaunchGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [...flowGuards.guards],
})
export class ContactInfoRoutingModule {}
